import React, { useMemo } from 'react';
import './index.scss';
import ChannelLabel from '@/pages/opinion/components/ChannelLabel';
import Score from './Score';
import { tweetsRenderList } from '@/pages/opinion/components/ReviewsModal/constants';
import { useIntl } from 'umi';
import { MetacriticScore } from '@/pages/opinion/components/MetacriticScore';
import SteamRatingColumns from '@/pages/opinion/components/SteamRatingColumns';
import KeywordAccount from '@/pages/opinion/components/KeywordAccount';

const JustifiedData = ({ data }: any) => {
  const { formatMessage } = useIntl();

  const [element, channel] = useMemo(() => {
    const channel = data.channel_name;
    const elementMap: any = {
      metacritic: <MetacriticScore isColumns={false} data={data} />,
      opencritic: <MetacriticScore isColumns={false} data={data} />,
      steam: (
        <SteamRatingColumns {...data} isColumns={false}></SteamRatingColumns>
      ),
      'google play': <Score data={data} />,
      'app store': <Score data={data} />,
      taptap: <Score data={data} />,
    };
    let element = elementMap[channel];
    if (element) {
      return [element, channel];
    }

    function getKeywordAccount() {
      const { monitor_source } = data || { monitor_source: [] };
      return (
        <div className="dbo-justified-left-text">
          <KeywordAccount monitor_source={monitor_source}></KeywordAccount>
        </div>
      );
    }

    return [getKeywordAccount(), channel];
  }, [data]);

  return (
    <div className="dbo-justified">
      <div className="dbo-justified-left">
        <ChannelLabel channel_name={channel} />
        {element}
      </div>
      {['metacritic', 'steam', 'google play', 'opencritic'].includes(
        data.channelName,
      ) ? null : (
        <div className="dbo-justified-right">
          {tweetsRenderList.map(({ key, text }) => {
            const value = data[key] >= 0 ? data[key] : 0;
            return (
              <div key={key} className="dbo-justified-right-item">
                <span className="dbo-justified-num">{value}</span>
                {formatMessage({ id: text })}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default JustifiedData;
